import { useState } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { ZoomIn, ZoomOut, RotateCcw, Loader2 } from "lucide-react";

const Btn = ({ onClick, label, testid, children }) => (
  <button type="button" onClick={onClick} aria-label={label} data-testid={testid}
    className="w-10 h-10 rounded-full bg-ink/85 text-parchment hover:bg-gold hover:text-ink flex items-center justify-center transition-colors">
    {children}
  </button>
);

export const ZoomableMap = ({ src, alt }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <TransformWrapper minScale={1} maxScale={6} doubleClick={{ mode: "toggle", step: 1.2 }} wheel={{ step: 0.15 }} centerOnInit>
      {({ zoomIn, zoomOut, resetTransform }) => (
        <div data-testid="zoomable-map" className="relative rounded-xl overflow-hidden bg-ink/5 border border-border">
          <TransformComponent wrapperStyle={{ width: "100%", height: "min(78vh, 900px)" }} contentStyle={{ width: "100%", height: "100%" }}>
            <img src={src} alt={alt} onLoad={() => setLoaded(true)} draggable={false}
              className={`w-full h-full object-contain select-none transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0"}`} />
          </TransformComponent>
          {!loaded && (
            <div data-testid="map-loading" className="absolute inset-0 flex flex-col items-center justify-center text-ink/50 pointer-events-none">
              <Loader2 className="w-8 h-8 animate-spin text-gold" />
              <p className="mt-2 font-mono text-xs uppercase tracking-widest">Loading high-resolution map…</p>
            </div>
          )}
          <div className="absolute bottom-3 right-3 flex gap-2">
            <Btn onClick={() => zoomIn(0.6)} label="Zoom in" testid="map-zoom-in"><ZoomIn className="w-5 h-5" /></Btn>
            <Btn onClick={() => zoomOut(0.6)} label="Zoom out" testid="map-zoom-out"><ZoomOut className="w-5 h-5" /></Btn>
            <Btn onClick={() => resetTransform()} label="Reset zoom" testid="map-zoom-reset"><RotateCcw className="w-5 h-5" /></Btn>
          </div>
          <p className="absolute top-3 left-3 bg-ink/70 text-parchment text-[11px] rounded-full px-3 py-1 pointer-events-none">
            Pinch, scroll or double-tap to zoom · drag to move
          </p>
        </div>
      )}
    </TransformWrapper>
  );
};
